import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
import { useAppSettings } from '@!/Hooks/useAppSettings'
const MonthlyCourseUnregister = lazy(() => import('@!/User/MonthlyCourseUnregister/containers/MonthlyCourseUnregister'))

const MonthlyCourseUnregisterApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <MonthlyCourseUnregister registers={props.registers} />
      </Suspense>
    </AppProvider>
  )
}

export default MonthlyCourseUnregisterApp
